'use es6';

import http from 'hub-http-rxjs/clients/apiClient';
import { map } from 'rxjs/operators/map';
import HubDbRows from '../models/HubDbRows';
import HubDbTable from '../models/HubDbTable';
const HUBDB_BASE_PATH = 'hubdb/api/v2';
export default {
  fetchRows(tableId) {
    return http.get(`${HUBDB_BASE_PATH}/tables/${tableId}/rows`).pipe(map(HubDbRows.fromJS));
  },

  fetchTable(id) {
    return http.get(`${HUBDB_BASE_PATH}/tables/${id}`).pipe(map(HubDbTable.fromJS));
  }

};